module.exports = __webpack_public_path__ + "img/tienda-petco.7ee002ed.png";